export default {
  errorFetching: false,
  loading: false,
  query: '',
  results: null,
  result: null,
  resultLayer: null
}
